/* tslint:disable */
/* eslint-disable */
/**
 * Oil refinery process modeling system
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.2.4
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import type {
  Component,
  DefaultModelIn,
  ElementGroup,
  HTTPValidationError,
  LumpComponent,
  Model,
  ProfilerMode,
  PureComponentClassEnum
} from '../models/index';
import {
  ComponentFromJSON,
  ComponentToJSON,
  DefaultModelInFromJSON,
  DefaultModelInToJSON,
  ElementGroupFromJSON,
  ElementGroupToJSON,
  HTTPValidationErrorFromJSON,
  HTTPValidationErrorToJSON,
  LumpComponentFromJSON,
  LumpComponentToJSON,
  ModelFromJSON,
  ModelToJSON,
  ProfilerModeFromJSON,
  ProfilerModeToJSON,
  PureComponentClassEnumFromJSON,
  PureComponentClassEnumToJSON
} from '../models/index';

export interface CatalogsGetElementsCatalogRequest {
  xProfilerMode?: ProfilerMode;
  xSessionId?: string | null;
}

export interface CatalogsGetInTouchModuleRequest {
  modelUuid: string;
  xProfilerMode?: ProfilerMode;
  xSessionId?: string | null;
}

export interface CatalogsGetInTouchModulesRequest {
  xProfilerMode?: ProfilerMode;
  xSessionId?: string | null;
}

export interface CatalogsGetLumpComponentsCatalogRequest {
  name?: string | null;
  modelTypeUuid?: string | null;
  xProfilerMode?: ProfilerMode;
  xSessionId?: string | null;
}

export interface CatalogsGetModelsCatalogRequest {
  xProfilerMode?: ProfilerMode;
  xSessionId?: string | null;
}

export interface CatalogsGetPureComponentsCatalogRequest {
  name?: string | null;
  _class?: PureComponentClassEnum | null;
  xProfilerMode?: ProfilerMode;
  xSessionId?: string | null;
}

export interface CatalogsSetDefaultModelRequest {
  defaultModelIn: DefaultModelIn;
  xProfilerMode?: ProfilerMode;
  xSessionId?: string | null;
}

/**
 *
 */
export class CatalogsApi extends runtime.BaseAPI {
  /**
   * Get Elements Catalog
   */
  async catalogsGetElementsCatalogRaw(
    requestParameters: CatalogsGetElementsCatalogRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Array<ElementGroup>>> {
    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (requestParameters['xProfilerMode'] != null) {
      headerParameters['X-Profiler-Mode'] = String(requestParameters['xProfilerMode']);
    }

    if (requestParameters['xSessionId'] != null) {
      headerParameters['X-Session-Id'] = String(requestParameters['xSessionId']);
    }

    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters['Authorization'] = await this.configuration.accessToken('OpenIdConnect', []);
    }

    const response = await this.request(
      {
        path: `/api/public/v1/catalog/elements`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      jsonValue.map(ElementGroupFromJSON)
    );
  }

  /**
   * Get Elements Catalog
   */
  async catalogsGetElementsCatalog(
    requestParameters: CatalogsGetElementsCatalogRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Array<ElementGroup>> {
    const response = await this.catalogsGetElementsCatalogRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Get In Touch Module
   */
  async catalogsGetInTouchModuleRaw(
    requestParameters: CatalogsGetInTouchModuleRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<boolean>> {
    if (requestParameters['modelUuid'] == null) {
      throw new runtime.RequiredError(
        'modelUuid',
        'Required parameter "modelUuid" was null or undefined when calling catalogsGetInTouchModule().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (requestParameters['xProfilerMode'] != null) {
      headerParameters['X-Profiler-Mode'] = String(requestParameters['xProfilerMode']);
    }

    if (requestParameters['xSessionId'] != null) {
      headerParameters['X-Session-Id'] = String(requestParameters['xSessionId']);
    }

    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters['Authorization'] = await this.configuration.accessToken('OpenIdConnect', []);
    }

    const response = await this.request(
      {
        path: `/api/public/v1/catalog/_service/check_in_touch_modules/{model_uuid}`.replace(
          `{${'model_uuid'}}`,
          encodeURIComponent(String(requestParameters['modelUuid']))
        ),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters
      },
      initOverrides
    );

    if (this.isJsonMime(response.headers.get('content-type'))) {
      return new runtime.JSONApiResponse<boolean>(response);
    } else {
      return new runtime.TextApiResponse(response) as any;
    }
  }

  /**
   * Get In Touch Module
   */
  async catalogsGetInTouchModule(
    requestParameters: CatalogsGetInTouchModuleRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<boolean> {
    const response = await this.catalogsGetInTouchModuleRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Get In Touch Modules
   */
  async catalogsGetInTouchModulesRaw(
    requestParameters: CatalogsGetInTouchModulesRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<{[key: string]: Array<Model>}>> {
    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (requestParameters['xProfilerMode'] != null) {
      headerParameters['X-Profiler-Mode'] = String(requestParameters['xProfilerMode']);
    }

    if (requestParameters['xSessionId'] != null) {
      headerParameters['X-Session-Id'] = String(requestParameters['xSessionId']);
    }

    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters['Authorization'] = await this.configuration.accessToken('OpenIdConnect', []);
    }

    const response = await this.request(
      {
        path: `/api/public/v1/catalog/_service/check_in_touch_modules`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters
      },
      initOverrides
    );

    return new runtime.JSONApiResponse<any>(response);
  }

  /**
   * Get In Touch Modules
   */
  async catalogsGetInTouchModules(
    requestParameters: CatalogsGetInTouchModulesRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<{[key: string]: Array<Model>}> {
    const response = await this.catalogsGetInTouchModulesRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Get Lump Components Catalog
   */
  async catalogsGetLumpComponentsCatalogRaw(
    requestParameters: CatalogsGetLumpComponentsCatalogRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Array<LumpComponent>>> {
    const queryParameters: any = {};

    if (requestParameters['name'] != null) {
      queryParameters['name'] = requestParameters['name'];
    }

    if (requestParameters['modelTypeUuid'] != null) {
      queryParameters['model_type_uuid'] = requestParameters['modelTypeUuid'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (requestParameters['xProfilerMode'] != null) {
      headerParameters['X-Profiler-Mode'] = String(requestParameters['xProfilerMode']);
    }

    if (requestParameters['xSessionId'] != null) {
      headerParameters['X-Session-Id'] = String(requestParameters['xSessionId']);
    }

    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters['Authorization'] = await this.configuration.accessToken('OpenIdConnect', []);
    }

    const response = await this.request(
      {
        path: `/api/public/v1/catalog/lump-components`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      jsonValue.map(LumpComponentFromJSON)
    );
  }

  /**
   * Get Lump Components Catalog
   */
  async catalogsGetLumpComponentsCatalog(
    requestParameters: CatalogsGetLumpComponentsCatalogRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Array<LumpComponent>> {
    const response = await this.catalogsGetLumpComponentsCatalogRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Get Models Catalog
   */
  async catalogsGetModelsCatalogRaw(
    requestParameters: CatalogsGetModelsCatalogRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Array<Model>>> {
    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (requestParameters['xProfilerMode'] != null) {
      headerParameters['X-Profiler-Mode'] = String(requestParameters['xProfilerMode']);
    }

    if (requestParameters['xSessionId'] != null) {
      headerParameters['X-Session-Id'] = String(requestParameters['xSessionId']);
    }

    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters['Authorization'] = await this.configuration.accessToken('OpenIdConnect', []);
    }

    const response = await this.request(
      {
        path: `/api/public/v1/catalog/models`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ModelFromJSON));
  }

  /**
   * Get Models Catalog
   */
  async catalogsGetModelsCatalog(
    requestParameters: CatalogsGetModelsCatalogRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Array<Model>> {
    const response = await this.catalogsGetModelsCatalogRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Get Pure Components Catalog
   */
  async catalogsGetPureComponentsCatalogRaw(
    requestParameters: CatalogsGetPureComponentsCatalogRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Array<Component>>> {
    const queryParameters: any = {};

    if (requestParameters['name'] != null) {
      queryParameters['name'] = requestParameters['name'];
    }

    if (requestParameters['_class'] != null) {
      queryParameters['class_'] = requestParameters['_class'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (requestParameters['xProfilerMode'] != null) {
      headerParameters['X-Profiler-Mode'] = String(requestParameters['xProfilerMode']);
    }

    if (requestParameters['xSessionId'] != null) {
      headerParameters['X-Session-Id'] = String(requestParameters['xSessionId']);
    }

    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters['Authorization'] = await this.configuration.accessToken('OpenIdConnect', []);
    }

    const response = await this.request(
      {
        path: `/api/public/v1/catalog/pure-components`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ComponentFromJSON));
  }

  /**
   * Get Pure Components Catalog
   */
  async catalogsGetPureComponentsCatalog(
    requestParameters: CatalogsGetPureComponentsCatalogRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Array<Component>> {
    const response = await this.catalogsGetPureComponentsCatalogRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Set Default Model
   */
  async catalogsSetDefaultModelRaw(
    requestParameters: CatalogsSetDefaultModelRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<any>> {
    if (requestParameters['defaultModelIn'] == null) {
      throw new runtime.RequiredError(
        'defaultModelIn',
        'Required parameter "defaultModelIn" was null or undefined when calling catalogsSetDefaultModel().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    if (requestParameters['xProfilerMode'] != null) {
      headerParameters['X-Profiler-Mode'] = String(requestParameters['xProfilerMode']);
    }

    if (requestParameters['xSessionId'] != null) {
      headerParameters['X-Session-Id'] = String(requestParameters['xSessionId']);
    }

    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters['Authorization'] = await this.configuration.accessToken('OpenIdConnect', []);
    }

    const response = await this.request(
      {
        path: `/api/public/v1/catalog/default-models`,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: DefaultModelInToJSON(requestParameters['defaultModelIn'])
      },
      initOverrides
    );

    if (this.isJsonMime(response.headers.get('content-type'))) {
      return new runtime.JSONApiResponse<any>(response);
    } else {
      return new runtime.TextApiResponse(response) as any;
    }
  }

  /**
   * Set Default Model
   */
  async catalogsSetDefaultModel(
    requestParameters: CatalogsSetDefaultModelRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<any> {
    const response = await this.catalogsSetDefaultModelRaw(requestParameters, initOverrides);
    return await response.value();
  }
}
